export const CHANGE_PROFILE = 'CHANGE_PROFILE';
export const OPEN_MORE_MENU = 'OPEN_MORE_MENU';
export const OPEN_LOGOUT = 'OPEN_LOGOUT';
